<template>
  <div class="about">
    <van-tabs v-model="active"
              border
              animated
              title-active-color="#263e65">
      <van-tab title="关于助学">
        <div class="container">
          <div class="detail">
            <p>助学于2006年开始运营，为了响应不断增加的国际学生的留学需求，助学逐渐发展成为专门为国际学生留学提供便捷之路的网络，在助学网上有者世界各地国际学生所需求和关系的主要在线资源。我们的目标是帮助这些学生能够实现他们的求学梦想，看到更加广阔的世界，增进他们对教育的理解，增加双边交流。我们希望以一切可以想象的方式帮助学生，使他们在国际教育事业中取得成功。 </p>
          </div>
          <div class="huanjing">
            <van-row gutter="10">
              <van-col span="24">
                <div class="xyimg">
                  <van-image :src="require('@/assets/aboutzhuxue.jpg')"
                             width="100%"
                             height="100%"
                             fill="fill" />
                </div>
              </van-col>
            </van-row>
          </div>
          <div class="detail">
            <p>随着国际教育的持续繁荣，我们致力于通过为国际学生提供最好的资源、信息、服务和产品来保持我们的领导地位，帮助国际学生更容易地申请中国大学。在这个国际学生网站上，你可以找到对国际学生在中国学习有用的建议页面，还有一个专门为想在中国各地求学、生活、旅行和工作的国际学生设立的留学中心。你还可以找到关于学生健康保险、国际电话卡、各类奖学金、旅行和其他有用的信息，帮助学生为出国旅行做好准备。我们有丰富的出版物和在线资源提供给我们的国际学生，我们打算用这种方式最好的服务我们的国际留学生。</p>
          </div>
        </div>
        <div class="botline">
          没有更多了
        </div>
      </van-tab>
      <van-tab title="助学优势">
        <div class="container">
          <div class="youshi">
            <p>在申请出国留学的大学时，最重要的是选择正确的大学和专业。你需要比较不同的选择，才能做出最好的选择，并找到一个值得你花4年或更长时间的学校完成你的学业。像“助学”这样的服务有一个优势，那就是直接帮助你连线大学和项目，直接与学校国际处老师进行沟通和了解，获得最前沿、最值得信任的咨询服务。</p>
            <p>助学与中国400多所大学和学院合作，并且数量持续增长。你可以通过我们的平台直接与高校对话，说出你的申请需求，获得你的申请资格。申请就是这么方便快捷。</p>
            <p>感谢我们的合作大学和学院，我们有300多个高科技高技术人才培养项目供您选择：中国氢能重卡、新药创制、特高压直流电、核心电子器件等等。高科技项目带你了解中国，学习知识，为你的未来创造无限可能。</p>
            <p>为了便于申请奖学金，助学与中国100多所大学合作，所有这些大学都将其奖学金项目放在助学中国奖学金平台上，您可以从中选择并申请；也可以通过我们的大学顾问咨询了解后申请。</p>
            <p>助学可以帮助你在中国70多个城市选择大学。从新疆到上海，从黑龙江到海南，你总能找到你在中国学习的目的地。</p>
            <p>申请中国大学是一项严肃的工作，我们为你推荐心仪的高校，同时为你提供其他服务,例如：汉语通关考试指导、来华签证办理、保险办理、银行卡办理、机票预定、酒店预定、接机服务、实习项目等。你需要一个值得信赖的服务平台，助学已经帮助很多来华留学生，也获得了很多用户的信任。</p>
            <div class="youshiTit">准确性</div>
            <p>对于一个综合服务平台来说，提供准确的信息服务是首要作用。无论是一个高校的信息对接，还是奖学金的申请递交，助学团队总是尽力做到精益求精。随着助学团队的不断努力，越来越多的高校加入我们，一起协同服务。对于奖学金项目，你可以看到明确的奖学金金额及申请流程。为了使我们的信息更加及时有效，我们的团队与各高校保持密切沟通，每月更新高校新项目。这就是为什么你可以在ZHUXUE上找到第一手信息。</p>
            <div class="youshiTit">免费连接中国大学申请服务</div>
            <p>为申请来华留学的国际学生提供免费建议。免费的申请支持服务将最大限度地提高你被中国大学课程录取的机会。这项服务对所有国际学生免费。</p>
            <p>我们与中国大学的密切关系使您在提交ZX-CSCSE application申请前得到审核，并比您自己申请更快地收到录取通知。这项服务意味着，ZHUXUE 98%的申请人都收到了首选大学的录取通知，而独立申请的只有55%。</p>
            <p>我们已经为中方院校输送了数万名学生，你可能就是下一个。包含哪些呢？</p>
            <ul>
              <li> <span>
                  <van-icon name="passed" />
                </span> 通过电话或微信，免费咨询在北京的顾问40分钟，了解国内大学 </li>
              <li> <span>
                  <van-icon name="passed" />
                </span> 推荐申请大学名单 </li>
              <li> <span>
                  <van-icon name="passed" />
                </span> 我们将向您提供并审阅您的申请表 </li>
              <li> <span>
                  <van-icon name="passed" />
                </span> 复核你的个人陈述 </li>
              <li> <span>
                  <van-icon name="passed" />
                </span> 关于中国大学需要哪些文件的建议 </li>
              <li> <span>
                  <van-icon name="passed" />
                </span> 关于可用奖学金的建议 </li>
              <li> <span>
                  <van-icon name="passed" />
                </span> 关于决定接受哪个提议的建议 </li>
              <li> <span>
                  <van-icon name="passed" />
                </span> 支持整个申请过程直到注册 </li>
            </ul>
            <p>如果您想要ZHUXUE提供以上所有服务，并保证您获得某所心仪中国大学的录取，请了解更多关于高级服务的信息。</p>
            <div class="youshiTit">服务</div>
            <div class="items">
              <div class="items_lis"><i>1</i> 助学合作高校免费咨询服务</div>
              <div class="items_lis"><i>2</i> 收费申请咨询服务</div>
              <div class="items_lis"><i>3</i> 当天服务</div>
              <div class="items_lis"><i>4</i> 学校推荐</div>
              <div class="items_lis"><i>5</i> MBBS申请咨询服务</div>
              <div class="items_lis"><i>6</i> PHD申请咨询服务</div>
              <div class="items_lis"><i>7</i> 签证服务</div>
              <div class="items_lis"><i>8</i> 来华服务</div>
              <div class="items_lis"><i>9</i> 汉语通关课服务</div>
            </div>
            <div class="youshiTit">可信度</div>
            <p>助学不是中介，与高校的合作是很重要的。每当有大学或机构想要与我们为学生共同服务，我们都会进行充分的调查，了解项目的优势和特色，以确保我们的学生免受不必要的麻烦。我们的合作伙伴包括清华大学、浙江大学、上海交通大学、武汉大学等顶尖大学。</p>
            <div class="youshiTit">认可度</div>
            <p>大多数中国大学、官方机构以及国际组织都是助学的合格的合作伙伴。</p>
            <van-row gutter="10">
              <van-col span="8">
                <div class="hezuoimg">
                  <van-image :src="require('@/assets/hezuologo.png')" />
                </div>
              </van-col>
              <van-col span="8">
                <div class="hezuoimg">
                  <van-image :src="require('@/assets/hezuologo.png')" />
                </div>
              </van-col>
              <van-col span="8">
                <div class="hezuoimg">
                  <van-image :src="require('@/assets/hezuologo.png')" />
                </div>
              </van-col>
              <van-col span="8">
                <div class="hezuoimg">
                  <van-image :src="require('@/assets/hezuologo.png')" />
                </div>
              </van-col>
              <van-col span="8">
                <div class="hezuoimg">
                  <van-image :src="require('@/assets/hezuologo.png')" />
                </div>
              </van-col>
              <van-col span="8">
                <div class="hezuoimg">
                  <van-image :src="require('@/assets/hezuologo.png')" />
                </div>
              </van-col>
            </van-row>
            <div class="youshiTit">最受欢迎</div>
            <p>助学最受国际学生的信任，也是大多数学生申请中国大学的最信任平台。每年有来自200国歌国家的10万多名国际学生咨询了解，有4000多名学生提交入学申请。我们是这个行业大多数人的选择。</p>
            <p>助学是中国最值得信赖的大学申请平台。</p>
            <p><b>赶紧加入吧！</b></p>

          </div>
        </div>
        <div class="botline">
          没有更多了
        </div>
      </van-tab>
      <van-tab title="合作伙伴">
        <div class="container hezuo">
          <van-row gutter="10">
            <van-col span="8"
                     v-for="(item,index) in hezuolist"
                     :key="index">
              <div class="hezuo-lis">
                <div class="imgbox">
                  <img :src="item.src"
                       alt="">
                </div>
              </div>
            </van-col>
          </van-row>
        </div>
        <div class="nomore">
          没有更多了
        </div>
      </van-tab>
      <van-tab title="联系我们">
        <div class="contact">
          <div class="imgbox">
            <img src="@/assets/about111.png"
                 alt="">
          </div>
          <van-cell title="地址"
                    icon="location">
            <!-- 使用 right-icon 插槽来自定义右侧图标 -->
            <template #right-icon>
              <p class="rightCont">北京 <span>(中国)</span></p>
            </template>
          </van-cell>
          <van-cell title="联系方式"
                    icon="phone">
            <!-- 使用 right-icon 插槽来自定义右侧图标 -->
            <template #right-icon>
              <p class="rightCont">+86-10-62040776</p>
            </template>
          </van-cell>
          <van-cell title="邮箱"
                    icon="comment">
            <!-- 使用 right-icon 插槽来自定义右侧图标 -->
            <template #right-icon>
              <p class="rightCont"><span>zhuxueedu@gmail.com</span></p>
            </template>
          </van-cell>
        </div>
        <div class="nomore">
          没有更多了
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>


<script>
import axiosApi from "../api/api.js";

export default {
  data () {
    return {
      active: 0,
      schoolDetail: [],
      hezuolist: [
        { src: require('@/assets/hezuo.jpg') },
        { src: require('@/assets/hezuo.jpg') },
        { src: require('@/assets/hezuo.jpg') }
      ]
    }
  },
  mounted () {
    const ids = this.$route.params.index
    if (ids == 0) this.active = 0
    if (ids == 1) this.active = 1
    if (ids == 2) this.active = 2
    if (ids == 3) this.active = 3
    axiosApi(
      'university/' + 1, {}, 'get'
    ).then((res) => {
      this.schoolDetail = res.data
    })
  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>
.container {
  padding: 25px;
}
p {
  text-align: justify;
}
.detail {
  text-indent: 2em;
  font-size: 28px;
  margin-bottom: 20px;
}

.youshi {
  font-size: 28px;
  p {
    margin-bottom: 20px;
    text-indent: 2em;
  }
  .youshiTit {
    border-left: 10px solid #263e65;
    line-height: 1;
    font-size: 32px;
    margin: 30px 0;
    padding-left: 10px;
  }
  ul {
    li {
      padding-left: 2em;
      margin-bottom: 10px;
      span {
        color: #263e65;
        margin-right: 10px;
      }
    }
  }
  .items {
    .items_lis {
      display: flex;
      border: 1px solid #263e65;
      margin-bottom: 20px;
      line-height: 50px;
      i {
        font-style: normal;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        color: #fff;
        background-color: #263e65;
        margin-right: 10px;
      }
    }
  }
  .hezuoimg {
    margin-bottom: 20px;
    .van-image {
      display: block;
    }
  }
}

.contact {
  .rightCont {
    color: #263e65;
  }
  .van-cell__left-icon {
    color: #263e65;
  }
}

.hezuo-lis {
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
}
.van-cell {
  padding-right: 60px;
}
</style>